<template>
  <div class="archive-download">
    <el-form :model="form" label-width="180px" size="small">
      <!-- 输入需下载学生 -->
      <el-form-item label="输入需下载学生：" required>
        <div class="upload-area">
          <el-upload
            ref="upload"
            :auto-upload="false"
            :on-change="handleFileChange"
            :file-list="fileList"
            :limit="1"
            accept=".xls,.xlsx"
            action="#">
            <el-button size="small" type="primary">上传文件</el-button>
          </el-upload>
          <el-link type="primary" @click="downloadTemplate">下载模板</el-link>
          <div class="tip">（注：一次仅支持导入5000人）</div>
        </div>
      </el-form-item>

      <!-- 选择下载文件 -->
      <el-form-item label="选择下载文件：" required>
        <div class="checkbox-group">
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="form.fileTypes">
            <el-checkbox label="topic">选题申请表</el-checkbox>
            <el-checkbox label="plan">项目实施计划书</el-checkbox>
            <el-checkbox label="result">成果报告</el-checkbox>
            <el-checkbox label="eval">企业评价表</el-checkbox>
            <el-checkbox label="summary">个人心得</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>

    <!-- 操作按钮 -->
    <div class="footer">
      <el-button size="small" @click="handleClose">关闭窗口</el-button>
      <el-button size="small" type="primary" :loading="downloading" @click="handleDownload">
        开始导出
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      form: {
        fileTypes: []
      },
      fileList: [],
      checkAll: false,
      downloading: false,
      batchId: ''
    }
  },
  mounted () {
    // 获取批次ID
    if (this.extraParams && this.extraParams.batchId) {
      this.batchId = this.extraParams.batchId
    }
  },
  methods: {
    // 下载模板
    downloadTemplate () {
      window.open('/workspace/manager/training/archive/downloadTemplate')
    },

    // 文件选择改变
    handleFileChange (file, fileList) {
      this.fileList = fileList
    },

    // 全选改变
    handleCheckAllChange (val) {
      this.form.fileTypes = val ? ['topic', 'plan', 'result', 'eval', 'summary'] : []
    },

    // 开始下载
    handleDownload () {
      // 校验文件
      if (this.fileList.length === 0) {
        this.$message.warning('请先上传学号文件')
        return
      }

      // 校验文件类型
      if (this.form.fileTypes.length === 0) {
        this.$message.warning('请至少选择一种文件类型')
        return
      }

      this.downloading = true

      // 构建FormData
      const formData = new FormData()
      formData.append('excelFile', this.fileList[0].raw)
      formData.append('batchId', this.batchId)
      formData.append('fileTypes', this.form.fileTypes.join(','))

      // 发送下载请求
      this.$ajax({
        url: '/workspace/manager/training/archive/downloadArchiveFiles',
        method: 'post',
        data: formData,
        responseType: 'blob',
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // 检查是否是错误响应
        if (response.data.type === 'application/json') {
          // 读取JSON错误信息
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result)
              this.$message.error(errorData.message || '下载失败')
            } catch (e) {
              this.$message.error('下载失败，请稍后重试')
            }
          }
          reader.readAsText(response.data)
          this.downloading = false
          return
        }

        // 下载文件
        const blob = new Blob([response.data], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        // 从响应头获取文件名
        let fileName = '综合训练归档.zip'
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/)
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1])
          }
        }
        link.download = fileName
        link.click()
        window.URL.revokeObjectURL(url)

        this.$message.success('下载成功')
        this.handleClose()
      }).catch(() => {
        this.$message.error('下载失败，请稍后重试')
      }).finally(() => {
        this.downloading = false
      })
    },

    // 关闭窗口
    handleClose () {
      this.$emit('update:visible', false)
    }
  },
  watch: {
    'form.fileTypes': {
      handler (val) {
        this.checkAll = val.length === 5
      }
    }
  }
}
</script>

<style lang="scss">
.archive-download {
  padding: 20px;

  .upload-area {
    display: flex;
    align-items: center;
    gap: 15px;

    .tip {
      color: #909399;
      font-size: 12px;
    }
  }

  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 10px;

    ::v-deep .el-checkbox-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-left: 20px;
    }
  }

  .footer {
    margin-top: 30px;
    text-align: right;
    border-top: 1px solid #e4e7ed;
    padding-top: 20px;
  }
}
</style>
